import React from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import CheckingCustomerSignup from '../CheckingCustomerSignup';

const CheckingProspectSignupController: React.FC = () => (
  <Routes>
    <Route
      data-feature="checking_customer_signup"
      index={true}
      element={<Navigate to="/checking/prospect_signup/identity" />}
    />
    <Route
      data-feature="checking_customer_signup"
      path="/identity/*"
      element={<CheckingCustomerSignup variant="prospect" />}
    />
  </Routes>
);

export default CheckingProspectSignupController;
